var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.625 9.89998V16.3375C24.625 20.1875 22.4251 21.8375 19.1251 21.8375H8.13754C7.57504 21.8375 7.03754 21.7875 6.53754 21.675C6.22504 21.625 5.92505 21.5375 5.65005 21.4375C3.77505 20.7375 2.63755 19.1125 2.63755 16.3375V9.89998C2.63755 6.04998 4.83754 4.40002 8.13754 4.40002H19.1251C21.9251 4.40002 23.9376 5.58752 24.4751 8.30002C24.5626 8.80002 24.625 9.31248 24.625 9.89998Z",
    stroke: "#101010",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3764 13.6501V20.0877C28.3764 23.9377 26.1764 25.5876 22.8764 25.5876H11.8889C10.9639 25.5876 10.1264 25.4627 9.40143 25.1877C7.91393 24.6377 6.90142 23.5002 6.53892 21.6752C7.03892 21.7877 7.57642 21.8376 8.13892 21.8376H19.1264C22.4264 21.8376 24.6264 20.1877 24.6264 16.3377V9.90013C24.6264 9.31263 24.5764 8.78767 24.4764 8.30017C26.8514 8.80017 28.3764 10.4751 28.3764 13.6501Z",
    stroke: "#101010",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6231 16.4249C15.4457 16.4249 16.9231 14.9474 16.9231 13.1248C16.9231 11.3023 15.4457 9.82483 13.6231 9.82483C11.8006 9.82483 10.3231 11.3023 10.3231 13.1248C10.3231 14.9474 11.8006 16.4249 13.6231 16.4249Z",
    stroke: "#101010",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47506 10.375V15.875",
    stroke: "#101010",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7772 10.3754V15.8754",
    stroke: "#101010",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneys);
export default __webpack_public_path__ + "static/media/moneys.8a7e64461b0f24341507a565a7379a35.svg";
export { ForwardRef as ReactComponent };